@if (transactionSuccessful) {
<app-barclay-success 
   
    [transactionID]="transactionID"
    [transactionDate]="transactionDate"
    [transactionAmount]="transactionAmount"
    [transactionCurrency]="transactionCurrency"
    (close)="ccPaymentComplete()"
></app-barclay-success>
}

@if (transactionFailed) {
<app-barclay-failed 
   
    [transactionErrorMessage]="transactionErrorMessage"
    [transactionErrorCode]="transactionErrorCode"
    [transactionErrorSuggestion]="transactionErrorSuggestion"
    (retryPayment)="retryPayment()"
    (close)="failedAndClose()"
></app-barclay-failed>
}